import { beforeAndAfter } from '../../../../FastExtend/utils';

// 基本是抄的以前的
export function handleAfterEvent({
    row, 
    column,
    value,
    oldValue,
    componentValue,
    moduleId,
    callback,
    type,
    store,
    activeTab,
}) {

    let { dataIndex, key } = row,
        { attrcode } = column;

    let val = value.value;

    // 为郭祉祺加的针对input类型时,这两个字段的特殊校验,换算率
    if (column.itemtype === 'input' && ['vchangerate', 'vqtunitrate'].includes(attrcode)) {
        let reg = /^([1-9][0-9]*|0)(\.\d{1,})?(\/)(([1-9][0-9]*)(\.\d{1,})?|(\d\.\d{1,}))$/;
        if (val && val.length < 1000 && !reg.test(val)) {
            // store.setCellProps(key, attrcode, { disabled: true });
            store.setCellValue(key, attrcode, { value: { value: null } });
            return;
        }
    }

    let changedRows = [];

    // editItem.props.hasOwnProperty('isMultiSelectedEnabled') && (isMul = editItem.props.isMultiSelectedEnabled);
    let isMulti = column.isMultiSelectedEnabled;
    if (column.refcode) {
        let refcode = column.refcode.replace('.js', '');
        if (refcode.startsWith('/')) refcode = refcode.substring(1);
        let refer = window[refcode] && window[refcode].default();
        if (refer && refer.props && refer.props.isMultiSelectedEnabled) {
            isMulti = refer.props.isMultiSelectedEnabled;
        }
    }
    // 多选参照的判断
    let valueArr = [];
    if (isMulti && oldValue) {
        let oldValArr = typeof oldValue.value === 'string' ? oldValue.value.split(',') :
            (Array.isArray(oldValue.value) ? oldValue.value : [oldValue.value]);

        let oldDisplayArr = typeof oldValue.display === 'string' ? oldValue.display.split(',') :
            (Array.isArray(oldValue.display) ? oldValue.display : [oldValue.display]);

        valueArr = typeof value.value === 'string' ? value.value.split(',') :
            (Array.isArray(value.value) ? value.value : [value.value]);

        valueArr.forEach((value, index) => {
            changedRows.push({
                rowid: key,
                newvalue: { value: value || '' },
                oldvalue: { value: oldValArr[index] || '', display: oldDisplayArr[index] || '' },
            });
        });
    } else {
        changedRows.push({
            rowid: key,
            newvalue: { value: val || '' },
            oldvalue: { value: oldValue.value || '', display: oldValue.display || '' },
        });
    }

    if (column.editAfterFlag && this.handleRelationItems) {
        this.handleRelationItems({
            type: 'table',
            areaCode: moduleId,
            key: attrcode,
            changedrows: changedRows,
            index: dataIndex,
            rowid: key,
            record: row,
            tableMetaCode: activeTab,
            column: column,
            callback: () => {
                let fxParams = {
                    moduleId,
                    record: store.getRowData(key),
                    attrcode: attrcode,
                    methods: this.output,
                    val: column.itemtype === 'refer' || column.itemtype === 'residtxt' ? componentValue : value.value,
                    changedRows,
                    index: dataIndex,
                    type: 'table',
                    actionTag: 'change', // 以前代码里的，不知道有啥用，留着
                    // actionTag: triggerType === 'onBlur' ? 'blur' : 'change',
                };
                beforeAndAfter(
                    this,
                    { moduleId, attrcode: attrcode, fxType: type, fxParams },
                    () => callback({ changedRows }),
                );
            },
        });
    } else {
        let fxParams = {
            moduleId,
            record: store.getRowData(key),
            attrcode: attrcode,
            methods: this.output,
            val: column.itemtype === 'refer' || column.itemtype === 'residtxt' ? componentValue : value.value,
            changedRows,
            index: dataIndex,
            type: 'table',
            actionTag: 'change', // 以前代码里的，不知道有啥用，留着
        };
        beforeAndAfter( 
            this,
            { moduleId, attrcode: attrcode, fxType: type, fxParams },
            () => callback({ changedRows }),
        );
    }
}